import getValueType from './getValueType';

// 深复制
function deepClone(obj) {
    let result;

    const type = getValueType(obj);
    // 如果是对象
    if (type === 'Object') {
        result = {};
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                result[key] = deepClone(obj[key]);
            }
        }
    // 如果是数组
    } else if (type === 'Array') {
        result = [];
        for (let i = 0, len = obj.length; i < len; i++) {
            result[i] = deepClone(obj[i]);
        }
    // 如果不是对象或数组
    } else {
        result = obj;
    }

    return result;
}

export default deepClone;


// WEBPACK FOOTER //
// ./src/components/shared/deepClone.js